<div class="background"></div>
<section>
  <div class="formations-intro">
    <img src="/assets/svg/hero_formation.svg" alt="Personne heureuse de suivre une formation" />
    <div>
      <h2>{{ 'home.formations.title' | translate }}</h2>
      <p class="gs1-little gs1-color-blue">{{ 'home.formations.description' | translate }}</p>
      <ul class="gs1-checklist">
        <li class="gs1-little">{{ 'home.formations.list.one' | translate }}</li>
        <li class="gs1-little">{{ 'home.formations.list.two' | translate }}</li>
        <li class="gs1-little">{{ 'home.formations.list.three' | translate }}</li>
      </ul>
      <a gs1Button [color]="'orange'" [href]="formationsLink" target="_blank" rel="noopener" (click)="trackFormation()">{{ 'home.formations.button' | translate }}</a>
    </div>
  </div>
  <div class="formations-list">
    @for (item of formations; track $index) {
      <gs1-card [size]="'small'" [name]="'formation-' + $index" [title]="item.title | translate" [text]="item.description | translate">
        <gs1-chip [color]="item.color">{{ item.chip | translate }}</gs1-chip>
        <a gs1Button [color]="'blue'" [href]="item.link" target="_blank" rel="noopener" (click)="trackFormation(item.title)">{{ item.button | translate }}</a>
      </gs1-card>
    }
  </div>
</section>
